import { useEffect, useState } from "react";
import ScannerTable from "../components/ScannerTable";
import { watchlistService } from "../services/watchlistService";
import { Box, Typography, Container, Paper } from "@mui/material";
import LoadingSpinner from "../components/LoadinSpinner";
import { useLivePrices } from "../hooks/useLivePrices";
import StaleDataAlert from "../components/StaleDataAlert";
import { useMarketStatus } from "../hooks/useMarketStatus";

const WatchlistPage = () => {
  const [results, setResults] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { prices, getLivePrice } = useLivePrices();
  const { marketStatus } = useMarketStatus();

  useEffect(() => {
    const fetchWatchlist = async () => {
      try {
        const data = await watchlistService.getWatchlist();
        setResults(data);

        // Extract tokens for live prices
        const tokens = data
          .map((item: any) => Number(item.instrument_token))
          .filter(Boolean);
        
        if (tokens.length > 0) {
          getLivePrice(tokens);
        }
      } catch (error) {
        console.error("Failed to fetch watchlist:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWatchlist();
  }, []);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <LoadingSpinner width="50px" height="50px" />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
      <Box sx={{ p: 0, borderRadius: 2 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            borderBottom: "1px solid #e0dcdc",
            marginBottom: "15px",
            gap: "10px",
            paddingBottom: "10px"
          }}
        >
          <h4 className="text-2xl font-bold">
            ⭐ Personalized Watchlist
          </h4>
          <Typography variant="body2" color="textSecondary">
            Manage your favorited picks and track their performance.
          </Typography>
        </div>
        
        <StaleDataAlert 
          isStale={marketStatus?.dataHealth?.isStale} 
          lastDataDate={marketStatus?.dataHealth?.lastDataDate} 
        />
        
        {results.length === 0 ? (
          <Box py={10} textAlign="center">
            <Typography variant="h6" color="textSecondary">
              Your watchlist is empty.
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Go to the scanner page and click the star icon to add stocks here.
            </Typography>
          </Box>
        ) : (
          <ScannerTable results={results} isLoading={false} prices={prices as any} />
        )}
      </Box>
    </Box>
  );
};

export default WatchlistPage;
